import { lock, unlock } from 'tua-body-scroll-lock'
import { debounce, formdataToObject } from '../utilities'
import {
  AJAX_URL,
  SEARCH_OPEN,
  LOADING_CLASS,
  MENU_OPEN,
  MODAL_OPEN,
} from '../utilities/constants'

export default class {
  constructor(el, options) {
    const formEl = el.querySelector('.js-searchForm')
    const searchInputEl = formEl.querySelector('.js-searchInput')
    const searchButtons = document.querySelectorAll('.js-searchToggle')
    const resultEl = el.querySelector('.js-searchResult')
    const messageEl = el.querySelector('.js-searchMessage')

    if (!searchButtons) {
      return
    }

    const searchContainer = el.querySelector('.js-searchScroll')

    const DEBOUNCE_TIME = 300

    Array.from(searchButtons).forEach((searchButton) => {
      searchButton.addEventListener('click', () => {
        if (document.documentElement.classList.contains(MENU_OPEN)) {
          document.documentElement.classList.remove(MENU_OPEN)
        }

        if (document.documentElement.classList.contains(MODAL_OPEN)) {
          document.documentElement.classList.remove(MODAL_OPEN)
        }

        const isOpening = document.documentElement.classList.toggle(SEARCH_OPEN)

        if (isOpening) {
          el.querySelector('a,input').focus({
            preventScroll: true,
          })
        }
      })
    })

    const url = new URL(window.location.href)
    if (url.searchParams.has('s')) {
      document.documentElement.classList.add(SEARCH_OPEN)

      el.querySelector('a,input').focus({
        preventScroll: true,
      })
    }

    window.addEventListener('keyup', (e) => {
      if (
        e.key === 'Escape' &&
        document.documentElement.classList.contains(SEARCH_OPEN)
      ) {
        document.documentElement.classList.remove(SEARCH_OPEN)
      }
    })

    let prevState = document.documentElement.classList.contains(SEARCH_OPEN)
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const isOpen = mutation.target.classList.contains(SEARCH_OPEN)

        if (isOpen === prevState) {
          return
        }

        if (isOpen) {
          lock(searchContainer)
        } else {
          unlock(searchContainer)
          // Remove ?s= from URL
          const url = new URL(window.location.href)
          url.searchParams.delete('s')
          window.history.replaceState({}, '', url)
        }

        prevState = isOpen
      })
    })

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    })

    /**
     * Search form
     */
    let formDataString = ''
    let prevFormDataString = ''

    async function searchRequest() {
      try {
        const formData = new FormData(formEl)

        if (options.action) {
          formData.append('action', options.action)
        }

        // Prevent search of same query
        formDataString = JSON.stringify(formdataToObject(formData))
        if (prevFormDataString === formDataString) {
          return false
        }

        prevFormDataString = formDataString

        el.classList.add(LOADING_CLASS)

        const response = await fetch(AJAX_URL, {
          method: 'POST',
          body: formData,
          mode: 'same-origin',
          credentials: 'same-origin',
        })

        if (options.debug) {
          console.info({ response })
        }

        const json = await response.json()

        if (options.debug) {
          console.info({ json })
        }

        return json
      } catch (e) {
        console.error({ e })
      } finally {
        el.classList.remove(LOADING_CLASS)
      }
    }

    async function performSearch(event) {
      if (event?.stopImmediatePropagation) {
        event.stopImmediatePropagation()
      }

      if (searchInputEl.value.length > 1) {
        const result = await searchRequest()

        if (result === false) {
          return
        }

        if (result?.items?.length) {
          resultEl.innerHTML = result.items
            .map(
              (item) => `
              <li class="Search-item">
                <a class="Search-itemLink" href="${item.url}">
                  ${
                    item.image
                      ? `
                    <div class="Search-itemMedia">
                      <img
                        class="Search-itemImage"
                        src="${item.image.url}"
                        ${
                          item.image.srcset
                            ? `srcset="${item.image.srcset}"`
                            : ''
                        }
                        sizes="(min-width: 5000px) 5000px, (min-width: 600px) 50vw, 100vw"
                        width="${item.image.width}"
                        height="${item.image.height}"
                        alt=""
                      />
                    </div>
                  `
                      : ''
                  }
                  <div class="Search-itemContent">
                    ${
                      item.meta
                        ? `<p class="Search-itemMeta">${item.meta} - ${item.type}</p>`
                        : ''
                    }
                    ${
                      item.title
                        ? `<p class="Search-itemTitle">${item.title}</p>`
                        : ''
                    }
                    ${
                      item.text
                        ? `<p class="Search-itemText">${item.text}</p>`
                        : ''
                    }
                  </div>
                </a>
              </li>
            `,
            )
            .join('')
        } else {
          resultEl.innerHTML = ''
        }

        messageEl.textContent = result.message ?? ''
      }
    }

    searchInputEl.addEventListener(
      'input',
      debounce((e) => {
        performSearch(e)
      }, DEBOUNCE_TIME),
    )

    const isTouch = window.matchMedia('(pointer: coarse)').matches
    if (isTouch) {
      searchInputEl.addEventListener(
        'keyup',
        (e) => e.key === 'Enter' && searchInputEl.blur(),
      )
    }

    searchInputEl.addEventListener(
      'change',
      debounce((e) => {
        performSearch(e)
      }, DEBOUNCE_TIME),
    )

    formEl.addEventListener('submit', (e) => {
      e.preventDefault()

      performSearch(e)

      return false
    })
  }
}
